import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DealerIdQueryService } from './shared/services/dealer-id-query/dealer-id-query.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  /** Ensures dealerId query param is synced to store on every navigation */
  private readonly dealerIdQuery = inject(DealerIdQueryService);
}
